import { DateField, TextField } from '@refinedev/antd';
import { Flex } from 'antd';
import { useTranslation } from 'react-i18next';

import CompanyLinkInfo from '@/components/general/CompanyLinkInfo';
import LinkTextField from '@/components/general/LinkTextField';
import { ShowInfoGrid, ShowInfoItem } from '@/components/general/ShowInfo/ShowInfo';
import { useCountryContext } from '@/contexts/CountryContext';
import { Shipment } from '@/model/Logistic/Shipment/Shipment';
import { PaymentsChoicesString } from '@/model/Logistic/Shipper/ShipperPayment';
import { Ticket } from '@/model/Ticket/Ticket';
import { RESOURCES } from '@/Resources';

interface ShipmentShowDetailProps {
  record?: Shipment;
  ticket?: Ticket;
}

const ShipmentShowDetail = (props: ShipmentShowDetailProps) => {
  const { isBrasilSelected } = useCountryContext();
  const { t } = useTranslation();
  const { record, ticket } = props;

  return (
    <ShowInfoGrid>
      <ShowInfoItem label={t('Empresa o Técnico que recibirá el paquete')}>
        <CompanyLinkInfo company={record?.company} />
      </ShowInfoItem>
      <ShowInfoItem label={isBrasilSelected ? 'CPF/CNPJ' : 'CUIT'}>
        <TextField value={record?.shipment_cuit ?? '-'} />
      </ShowInfoItem>

      <ShowInfoItem label={t('Operador logístico')}>
        <TextField value={record?.shipper?.name} />
      </ShowInfoItem>
      <ShowInfoItem label={t('Método de pago')}>
        <TextField
          value={record?.shipper_payment ? t(PaymentsChoicesString[record?.shipper_payment]) : '-'}
        />
      </ShowInfoItem>

      <ShowInfoItem label={t('Observaciones')}>
        <TextField value={record?.comment ?? '-'} />
      </ShowInfoItem>
      <ShowInfoItem label={t('Fecha de envío estimada')}>
        <DateField value={record?.date_estimated} />
      </ShowInfoItem>
      {record?.ticket && ticket && (
        <ShowInfoItem label={t('Ticket asociado')}>
          <Flex vertical>
            <LinkTextField
              label={`${ticket?.ticket_title_str} (${ticket?.id})`}
              to={`/tickets/show/${ticket?.id}`}
              local
            />
            <LinkTextField
              label={t('Ver caso completo')}
              to={`/${RESOURCES.CASE_RESOLUTION}/${ticket?.id}`}
              local
            />
          </Flex>
        </ShowInfoItem>
      )}
    </ShowInfoGrid>
  );
};

export default ShipmentShowDetail;
